import { render, staticRenderFns } from "./SurveySingleChoiceRadio.vue?vue&type=template&id=01d6842e&"
import script from "./SurveySingleChoiceRadio.vue?vue&type=script&lang=ts&"
export * from "./SurveySingleChoiceRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports